<template>
  <div class="login-card__welcome-card">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.welcome.header') }}<span>!</span></h1>
    </div>

    <validation-observer ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="login-card__gender-pick">
          <h2 class="login-card__gender-text">{{ trans.get('auth.card.gender.own.header') }}</h2>
        </div>

        <div class="form-row">
          <div class="form-group col-12 gender-selection">
            <validation-provider name="gender" rules="required" v-slot="{ errors }" mode="eager">
              <div class="gender-pick__wrapper">
                <input type="radio" value="male" id="male-gender" v-model="form.gender">
                <label class="preferred-gender preferred-gender__male" for="male-gender" :title="trans.get('auth.card.gender.male')" id="gender-male">
                  <img src="../../../images/registration/male.svg" class="preferred-gender__icon" />
                  {{ trans.get('common.male') }}
                </label>
                <input type="radio" value="female" id="female-gender" v-model="form.gender">
                <label class="preferred-gender preferred-gender__female" for="female-gender" :title="trans.get('auth.card.gender.female')" id="gender-female">
                  <img src="../../../images/registration/female.svg" class="preferred-gender__icon" />
                  {{ trans.get('common.female') }}
                </label>
              </div>
              <p class="text-danger">{{ errors[0] }}</p>
            </validation-provider>
          </div>
        </div>

        <div class="login-card__gender-pick">
          <h2 class="login-card__gender-text">{{ trans.get('auth.card.gender.preferred.header') }}</h2>
        </div>

        <div class="form-row">
          <div class="form-group col-12 gender-selection">
            <validation-provider name="preferred gender" rules="required" v-slot="{ errors }" mode="eager">
              <div class="gender-pick__wrapper">
                <input type="checkbox" value="male" id="preferred-male-gender" v-model="form.preferred_gender">
                <label class="preferred-gender preferred-gender__male" for="preferred-male-gender" :title="trans.get('common.male_official')" id="looking-for-male">
                  <img src="../../../images/registration/male.svg" class="preferred-gender__icon" />
                  {{ trans.get('common.male_official') }}
                </label>
                <input type="checkbox" value="female" id="preferred-female-gender" v-model="form.preferred_gender">
                <label class="preferred-gender preferred-gender__female" for="preferred-female-gender" :title="trans.get('common.female_official')" id="looking-for-female">
                  <img src="../../../images/registration/female.svg" class="preferred-gender__icon" />
                  {{ trans.get('common.female_official') }}
                </label>
              </div>
              <p class="text-danger">{{ errors[0] }}</p>
            </validation-provider>
          </div>
        </div>

        <button type="submit" class="gender-pick__button">{{ trans.get('auth.card.buttons.free_registration') }}
          <img src="../../../images/registration/arrow-right.svg" class="registration-button-arrow" />
        </button>
      </form>
    </validation-observer>
    <button class="login-card__link" @click="swapComponent('auth-login-card')">{{ trans.get('auth.card.welcome.member_already') }}<span>{{ trans.get('auth.card.welcome.log_in') }}</span></button>

    <div class="joined-users">
      <p class="title title--small title--color-secondary title--semi-bold">
        {{ trans.get('auth.card.registration_footer_join') }}
      </p>

      <div class="joined-users__photos">
        <div
          v-for="profile, index in profiles"
          :key="index"
          class="profile"
        >
          <a
            v-if="index <= 3"
            class="profile__link"
            :href="zRoute('front.profile.show', profile.id)"
          >
            <div
              class="profile__photo"
              :style="{ backgroundImage: `url(${profile.home_avatar_url})` }"
            >
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['swapComponent', 'form', 'profiles'],
  watch: {
    // 'form.gender': function (newValue, oldVale) {
    //     if (this.form.preferred_gender.length !== 0) {
    //         return;
    //     }
    //
    //     if (newValue === 'female') {
    //         this.form.preferred_gender = ['male'];
    //     }
    //
    //     if (newValue === 'male') {
    //         this.form.preferred_gender = ['female'];
    //     }
    // },
  },
  methods: {
    async refreshCSRFToken() {
      axios.get(zRoute('ajax.csrf_token'))
        .then(response => {
          const token = response.data.csrfToken;
          document.querySelector('meta[name=csrf-token]').setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
    onSubmit() {
      this.swapComponent('auth-register-email-card');
    }
  },
  activated() {
    this.refreshCSRFToken();
  }
};
</script>
<style scoped>
</style>
